import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConfirmModel {
  title: string;
  message: string;
  confirmButton: string;
  closeButton: string;
}

@Component({
    selector: 'app-confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.css'],
    standalone: false
})
export class ConfirmComponent implements OnInit {
  title: string;
  message: string;
  confirmButton: string;
  closeButton: string;

  constructor(private dialogRef: MatDialogRef<ConfirmComponent>, @Inject(MAT_DIALOG_DATA) private data: ConfirmModel) {
  }

  ngOnInit(): void {
    if (this.data.title) {
      this.title = this.data.title;
    }
    if (this.data.message) {
      this.message = this.data.message;
    }
    if (this.data.confirmButton) {
      this.confirmButton = this.data.confirmButton;
    }
    if (this.data.closeButton) {
      this.closeButton = this.data.closeButton;
    }
  }

  confirm() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
